import Command from '@ckeditor/ckeditor5-core/src/command';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import toMap from '@ckeditor/ckeditor5-utils/src/tomap';
import uid from '@ckeditor/ckeditor5-utils/src/uid';

function _addMentionAttributes(baseMentionData, data) {
  return { uid: uid(), ...baseMentionData, ...(data || {}) };
}
export class MentionCommand extends Command {
  refresh() {
    const { model } = this.editor;
    const doc = model.document;

    this.isEnabled = model.schema.checkAttributeInSelection(
      doc.selection,
      'mention',
    );
  }

  execute(options) {
    const { model } = this.editor;
    const { document } = model;
    const { selection } = document;

    const mentionData =
      typeof options.mention === 'string'
        ? { id: options.mention }
        : options.mention;
    const mentionID = mentionData.id;

    const range = options.range || selection.getFirstRange();

    const mentionText = options.text || mentionID;

    const mentionTextClean = mentionText.replace(/@/g, '');
    const mention = _addMentionAttributes(
      { _text: mentionTextClean, id: mentionID },
      mentionData,
    );

    // eslint-disable-next-line eqeqeq
    if (options.marker.length != 1) {
      throw new CKEditorError('mentioncommand-incorrect-marker', this);
    }

    if (mentionID.charAt(0) !== options.marker) {
      throw new CKEditorError('mentioncommand-incorrect-id', this);
    }

    model.change((writer) => {
      const currentAttributes = toMap(selection.getAttributes());
      const attributesWithMention = new Map(currentAttributes.entries());

      attributesWithMention.set('mention', mention);

      // Replace a range with the text with a mention.
      model.insertContent(
        writer.createText(mentionTextClean, attributesWithMention),
        range,
      );
      model.insertContent(
        writer.createText(' ', currentAttributes),
        range.start.getShiftedBy(mentionTextClean.length),
      );
    });
  }
}
